<div class="w-full h-full flex justify-center items-center bg-gray-50 p-4">
    <iframe [src]="pdfSafeSrc" type="application/pdf" class="w-full h-full rounded-lg shadow-lg border"
        style="min-height: 500px;">
    </iframe>
</div>